<template>
  <div class="footer" v-if="props.dashboard">
    <footer class="ed-grid s-grid-2 lg-grid-4 footer">
      <section class="card ed-grid s-cols-2 lg-cols-4 lg-grid-1">
        <div class="card s-to-center s-center">
          <h2 class="s-center">iQuela</h2>
          <p style="font-size: 18px" class="s-center">
            Reforzamos las habilidades y conocimientos de los futuros
            profesionales en tecnología.
          </p>
        </div>
        <nav class="card ed-grid s-grid-5 navegacion__rrss footer__rrss s-center">
          <a href="https://twitter.com/iQuela_Latam" target="_blank"
            ><i class="fab fa-twitter items-twitter"></i
          ></a>
          <a href="https://www.instagram.com/iquela_latam/" target="_blank"
            ><i class="fab fa-instagram items-instagram"></i
          ></a>
          <a href="https://www.facebook.com/iQuelaLatam/" target="_blank"
            ><i class="fab fa-facebook-square items-facebook"></i
          ></a>
          <a href="https://www.linkedin.com/company/iquela/" target="_blank"
            ><i class="fab fa-linkedin items-linkedin"></i
          ></a>
          <a
            href="https://www.tiktok.com/@iquela_latam?is_from_webapp=1&sender_device=pc"
            target="_blank"
            ><i class="fab fa-tiktok items-tiktok"></i
          ></a>
        </nav>
      </section>

      <hr class="card s-cols-2 lg-cols-4 s-center line" />
      <!-- seccion copyright -->
      <section
        class="card s-cols-2 lg-cols-4 s-to-center s-center footer__copyright"
      >
        <p>
          Copyright <i class="fa fa-copyright" aria-hidden="true"></i> iQuela
          2023. Todos los derechos reservados
        </p>
      </section>
    </footer>
  </div>

  <div class="footer" v-else>
    <footer class="ed-grid s-grid-2 lg-grid-4 footer">
      <section class="card ed-grid s-cols-2 lg-cols-1 lg-grid-1">
        <div class="card s-to-center s-center">
          <h2 class="s-center">iQuela</h2>
          <p style="font-size: 18px" class="s-center">
            Reforzamos las habilidades y conocimientos de los futuros
            profesionales en tecnología.
          </p>
        </div>
        <nav class="card ed-grid s-grid-5 footer__rrss s-center">
          <a href="https://twitter.com/iQuela_Latam" target="_blank"
            ><i class="fab fa-twitter items-twitter"></i
          ></a>
          <a href="https://www.instagram.com/iquela_latam/" target="_blank"
            ><i class="fab fa-instagram items-instagram"></i
          ></a>
          <a href="https://www.facebook.com/iQuelaLatam/" target="_blank"
            ><i class="fab fa-facebook-square items-facebook"></i
          ></a>
          <a href="https://www.linkedin.com/company/iquela/" target="_blank"
            ><i class="fab fa-linkedin items-linkedin"></i
          ></a>
          <a
            href="https://www.tiktok.com/@iquela_latam?is_from_webapp=1&sender_device=pc"
            target="_blank"
            ><i class="fab fa-tiktok items-tiktok"></i
          ></a>
        </nav>
      </section>
      <!-- compañia -->
      <section class="card s-to-center s-center">
        <h3>Compañia</h3>
        <nav>
          <!--           <router-link class="link" to="/sobre-nosotros"
            >Sobre nosotros</router-link
          > -->
          <!--         <router-link class="link" to="/nuestra-marca"
          >Nuestra marca</router-link
        > -->
          <!--     <router-link class="link" to="/como-funciona-iquela"
          >Como funciona iQuela</router-link
        > -->
          <router-link class="link" to="/planes">Planes</router-link>
        </nav>
      </section>
      <!-- comunidad -->
      <section class="card s-to-center s-center">
        <h3>Comunidad</h3>
        <nav>
          <router-link class="link" to="/historias-de-exito"
            >Historias de éxito</router-link
          >
          <!--        <router-link class="link" to="/proyectos-comunidad"
          >Proyectos de la comunidad</router-link
        > -->
        </nav>
      </section>
      <!-- ayuda -->
      <section class="card s-cols-2 lg-cols-1 s-to-center s-center">
        <h3>Ayuda</h3>
        <nav>
          <!--  <router-link class="link" to="/preguntas-frecuentes"
          >Preguntas frecuentes</router-link
        > -->
          <router-link class="link" to="/aviso-de-privacidad"
            >Aviso de privacidad</router-link
          >
          <router-link class="link" to="/condiciones-de-uso"
            >Condiciones de uso</router-link
          >
        </nav>
      </section>
      <hr class="card s-cols-2 lg-cols-4 s-center line" />
      <!-- seccion copyright -->
      <section
        class="card s-cols-2 lg-cols-4 s-to-center s-center footer__copyright"
      >
        <p>
          Copyright <i class="fa fa-copyright" aria-hidden="true"></i> iQuela
          2023. Todos los derechos reservados
        </p>
      </section>
    </footer>
  </div>
</template>
<script>
export default {
  props: {
    dashboard: null,
  },
  setup(props) {
    return {
      props,
    };
  },
};
</script>

<style lang="scss" scoped>
@import "../sass/footer.scss";
</style> 
